<div class="malou-card malou-shadow h-full rounded-[20px] bg-white px-0 pt-10 md:h-fit md:pt-6">
    <ng-container [ngTemplateOutlet]="diagnosticSent() ? diagnosticSentTemplate : informationFormTemplate"></ng-container>
</div>

<ng-template #informationFormTemplate>
    <div class="malou-card__header mb-8 flex flex-col !items-start px-8 sm:!px-5 md:mb-2 md:px-5 lg:px-14">
        <p class="malou-text-37--medium text-malou-text-title">{{ 'maloupe.diagnostic_information_form.header.title_1' | translate }}</p>
        <p class="malou-text-42--bold text-malou-text-title">{{ 'maloupe.diagnostic_information_form.header.title_2' | translate }}</p>
        <p class="malou-text-17--medium text-malou-blue opacity-70">
            {{ 'maloupe.diagnostic_information_form.header.subtitle' | translate }}
        </p>
    </div>

    <div class="malou-card__body flex-col">
        <div [id]="hubspotFormContainerId"></div>
    </div>
</ng-template>

<ng-template #diagnosticSentTemplate>
    <div class="flex h-full flex-col items-center justify-center px-8 sm:!px-5 md:mb-2 md:px-5 lg:px-14" id="'diagnostic-sent-container'">
        <img class="mb-8 h-[72px]" [src]="Icon.CHECK | imagePathResolver: { folder: 'icons' }" />
        <p class="malou-text-40--bold mb-4 font-passion-one text-malou-text-title sm:text-[35px]">
            {{ 'maloupe.diagnostic_information_form.form.diagnostic_sent' | translate }}
        </p>
        <p class="malou-text-16 sm:malou-text-14 text-center text-malou-text-title">
            {{ 'maloupe.diagnostic_information_form.form.mailbox_in_few_minutes' | translate }}
        </p>
        <div class="mt-16 flex flex-col items-center">
            <p class="malou-text-18 sm:malou-text-14 text-center text-malou-text-title">
                {{ 'maloupe.diagnostic_information_form.form.contact_information' | translate }}
            </p>
            <button
                class="!malou-text-18 sm:!malou-text-14 mt-5 w-fit !bg-malou-primary text-malou-white disabled:!text-malou-white"
                mat-flat-button
                (click)="redirectToCoachingSessionsPlanner()">
                {{ 'maloupe.diagnostic_information_form.form.plan_session' | translate }}
            </button>
        </div>
    </div>
</ng-template>
